import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import myDirective from "vue-touch-card-effect";
import VAvatar from "v-avatar";
import VCharts from "v-charts";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "devextreme/dist/css/dx.common.css";
// import 'devextreme/dist/css/dx.material.blue.light.css';

import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/base";
import "./plugins/chartist";
import VeeValidate from 'vee-validate'// import Vuelidate from 'vuelidate'
import jwt_decode from "jwt-decode";
// import "./plugins/vue-world-map";
import VueSplash from "vue-splash";
import JsonExcel from "vue-json-excel";
import QrcodeVue from 'qrcode.vue'
var VueCookie = require('vue-cookie');
Vue.use(VueCookie);
// import { createConnection, start } from "./userHub";
Vue.config.devtools = false;
Vue.config.productionTip = false;
Vue.use(VueSplash);
const moment = require("moment");
// require("moment/locale/ar");
moment.locale(localStorage.getItem("lang") == "en" ? "en" : "ar-dz");
Vue.use(require("vue-moment"), { moment });
// Vue.moment.locale("ar");
Vue.component("downloadExcel", JsonExcel);
Vue.use(VeeValidate, {
  inject: true,
  fieldsBagName: 'veeFields'
});
Vue.use(VAvatar);
Vue.use(QrcodeVue);
Vue.use(VCharts);

// Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios);
// if (axios.defaults.baseURL === "" || axios.defaults.baseURL === undefined) {
//   axios.get("static/config.json").then(res => {
//     axios.defaults.baseURL = res.data.VUE_APP_URL;
//     store.commit("SET_UPLOADER", res.data.VUE_APP_UPLOAD);
//     store.commit("SET_PATHURL", res.data.VUE_APP_FILE_URL);
//   });
// }
Vue.directive("touch-card", myDirective);
Vue.config.productionTip = false;
// axios.defaults.baseURL = process.env.VUE_APP_URL;
axios.defaults.headers.get.Accepts = "application/json";
axios.interceptors.request.use(
  config => {
    store.commit("overlay", true);
    const token = localStorage.getItem("token");
    const auth = token ? `Bearer ${token}` : "";
    config.headers.common.Authorization = auth;
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  function(response) {
    store.commit("overlay", false);
    return response;
  },
  function(error) {
    store.commit("overlay", false);
    if (error.response.status === 401 || error.response.status === 403) {
      // store.dispatch('logout')
      router.push({ name: "Login" });
    }
    return Promise.reject(error);
  }
);

Vue.mixin({
 
  computed: {},
  methods: {



    decodeToken() {
      if(store.state.decodedToken){
        return store.state.decodedToken;
      }
  
      const token = localStorage.getItem("token");
      var decoded=jwt_decode(token);
      store.commit("SET_DECODED_TOKEN",decoded);
      return decoded;

    },
    isInRole(role) {
      var roles = [this.decodeToken().role];
      return roles.indexOf(String(role)) > -1
    },
    getUserInfo(){
      var data=this.decodeToken();
      return {
        userId:data.unique_name,
        userType:data.personType,
        fullName:data.given_name,
        userName:data.email
      }
    }
  },
});

const variableName = vuetify.framework.theme.isDark ? "dark" : "light";
System.import(`devextreme/dist/css/dx.material.blue.${variableName}.css`);
if (localStorage.getItem("token")) {
  // createConnection();
  // start();
}
export const bus = new Vue();


new Vue({
  router,
  vuetify,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
